<template>
  <vs-popup
    fullscreen
    :title="`Sub-Kategori SOS dari Kategori ${passData.name}`"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <SyaratSlotSOS
      :activate="activeSyarat"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passSyarat"
    />
    <div class="vx-row justify-between mt-2 w-full">
      <section class="vx-col lg:w-2/5 sm:w-full">
        <main>
          <div class="mb-6 items-top">
            <section class="vx-row">
              <span
                :class="
                  itemEdit === null
                    ? 'text-black text-xl vx-col w-full'
                    : 'text-black text-xl vx-col w-4/5 overflow-visible'
                "
                ><strong>{{ titlePopUp }}</strong></span
              >
              <vs-icon
                v-if="itemEdit !== null"
                class="vx-col w-1/5 cursor-pointer"
                icon="clear"
                size="medium"
                color="#383838"
                @click="closeEdit"
              ></vs-icon>
            </section>
          </div>
          <div class="flex justify-start w-full gap-4 items-center mb-base">
            <img
              :src="
                formData.file !== null
                  ? formData.file.includes('upload/')
                    ? `${url.baseFl}/${formData.file}`
                    : formData.file
                  : emptyImage
              "
              alt="sub-kategori-sos-img"
              class="rounded-lg shadow-md cursor-pointer block mb-4"
            />
            <div>
              <input
                type="file"
                class="hidden"
                ref="updateImgInput"
                @change="updateCurrImg"
                accept="image/*"
              />
              <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.updateImgInput.click()"
                >Upload Gambar</vs-button
              >
              <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
            </div>
          </div>
          <div class="mb-4">
            <section class="mb-2 flex justify-start gap-1">
              <h6>Nama Sub-Kategori SOS</h6>
              <span class="text-danger">*</span>
            </section>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="sub-category name"
              class="w-full sidebar-input"
              v-model="formData.name"
              placeholder="Isi Dengan Nama Sub-kategori SOS"
            />
            <span class="text-danger text-sm">{{
              errors.first("sub-category name")
            }}</span>
          </div>
          <div class="mb-4">
            <section class="mb-2 flex justify-start gap-1">
              <h6>Deskripsi</h6>
              <span class="text-danger">*</span>
            </section>
            <vs-textarea
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="description"
              class="w-full sidebar-input"
              v-model="formData.description"
              placeholder="Isi Dengan Deskripsi Sub-kategori SOS"
            />
            <span class="text-danger text-sm">{{ errors.first("description") }}</span>
          </div>
          <div class="mb-4">
            <section class="mb-2 flex justify-start gap-1">
              <h6>Parent Sub-Kategori SOS</h6>
            </section>
            <vs-input
              v-if="passData.name"
              v-validate="'required'"
              data-vv-validate-on="blur"
              class="w-full sidebar-input"
              :disabled="true"
              v-model="passData.name"
              placeholder="Isi Dengan Nama Parent Sub-kategori SOS"
            />
          </div>
        </main>
        <footer class="mt-4">
          <div class="flex justify-end items-center mr-4 mb-4">
            <!-- <vs-button
          color="danger"
          class="mr-2 rounded-2xl"
          @click="closeWithLoad(false)"
          >Cancel</vs-button
        > -->
            <vs-button
              :color="itemEdit === null ? 'success' : 'warning'"
              class="ml-2 rounded-2xl"
              :disabled="!validateForm"
              @click="addWithOption"
              >{{ labelButton }}</vs-button
            >
          </div>
        </footer>
      </section>
      <section class="vx-col lg:w-3/5 sm:w-full">
        <header class="w-full">
          <div class="mb-base vx-row justify-between items-top">
            <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start"
            >
              <span class="text-black text-xl"><strong>Tabel Sub-Kategori</strong></span>
            </section>
            <!-- <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
            >
              <vs-button @click="openPopUp(null)" v-if="access.create === 1"
                >Tambah Kategori SOS</vs-button
              >
            </section> -->
          </div>
          <div class="vx-row justify-between items-center">
            <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
              <div class="w-full gap-2 flex justify-start items-center">
                <vs-button @click="actionsDelete">{{
                  selected.length === 0 ? "Hapus" : `Hapus ${selected.length} Item`
                }}</vs-button>
                <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <vs-button icon-after icon="expand_more">Aksi</vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="dialogDelete">
                      <span>Hapus</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{ `entries ${limit}` }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      v-for="(item, index) in limitDataTables"
                      :key="index"
                      @click="limit = item"
                    >
                      <span>{{ item }}</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
              </div>
            </section>
            <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
              <div class="w-full flex justify-end gap-2 flex-wrap items-center">
                <vs-input v-model="search" placeholder="Search..." />
              </div>
            </section>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
          ></div>
        </header>

        <main ref="loadSubKatSOS">
          <vs-table
            stripe
            :data="subKategoris"
            v-model="selected"
            :max-items="limit"
            multiple
          >
            <template slot="thead">
              <vs-th>Gambar</vs-th>
              <vs-th>Nama Sub-Kategori</vs-th>
              <vs-th>Aksi</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].file">
                  <img
                    key="indextr"
                    :src="
                      data[indextr].file
                        ? data[indextr].file.includes('http')
                          ? data[indextr].file
                          : `${url.baseFl}/${data[indextr].file}`
                        : emptyImage
                    "
                    alt="user-img"
                    class="rounded-lg shadow-md cursor-pointer block"
                  />
                </vs-td>
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>
                <vs-td>
                  <div
                    class="flex justify-start gap-2"
                    v-if="itemDelete !== data[indextr].id"
                  >
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click="openEdit(data[indextr])"
                    >
                    </vs-button>
                    <vs-button
                      color="warning"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-file"
                      @click="openPopUp(data[indextr])"
                    >
                    </vs-button>
                    <vs-button
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="itemDelete = data[indextr].id"
                    >
                    </vs-button>
                  </div>
                  <div class="flex justify-start gap-2" v-else>
                    <vs-button
                      color="danger"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="deleteItem(data[indextr].id)"
                    >
                      Delete
                    </vs-button>
                    <vs-button
                      color="#949494"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-x"
                      @click="itemDelete = null"
                    >
                      No
                    </vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </main>
        <footer>
          <div class="justify-end mt-2">
            <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
          </div>
        </footer>
      </section>
    </div>
  </vs-popup>
</template>

<script>
import SyaratSlotSOS from "@/views/sos/component/SyaratSlotSOS.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  components: {
    SyaratSlotSOS,
  },
  data() {
    return {
      emptyImage,
      url,
      params: {},
      limitDataTables,
      binaryFile: "",
      limit: limitDataTables[0],
      active: false,
      itemDelete: null,
      itemEdit: null,
      passSyarat: null,
      activeSyarat: false,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      subKategoris: [],
      search: "",
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      formData: {
        name: "",
        description: "",
        file: emptyImage,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.itemEdit != null ? "Edit Sub-Kategori" : "Tambah Sub-Kategori ";
    },
    labelButton() {
      return this.itemEdit != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.description !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    totalPage() {
      let pages = this.$store.state.sos.totalSubKatRecords / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    // activate() {
    //   if (this.activate === true) {
    //     this.getData();
    //   }
    // },
    search() {
      if (this.search !== "") {
        this.params = {
          search: this.search,
          filter: "name",
        };
      } else {
        this.params = {};
      }

      this.getData();
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    openPopUp(item) {
      this.activeSyarat = true;
      this.passSyarat = item;
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    callBackPopUp(val) {
      this.activeSyarat = val;
      this.passSyarat = null;
    },
    openEdit(val) {
      this.formData.name = val.name;
      this.formData.description = val.description;
      this.formData.file = this.getPathFoto(val);
      this.itemEdit = val;
    },
    closeEdit() {
      this.formData.name = "";
      this.formData.description = "";
      this.formData.file = this.emptyImage;
      this.binaryFile = "";
      this.itemEdit = null;
    },
    actionsDelete() {
      if (this.selected.length === 0) {
        this.$vs.notify({
          title: "Tidak ada item yang dipilih",
          text: "Pilihlah salah satu item atau semua item",
          color: "danger",
          position: "top-right",
        });
      } else {
        for (let i in this.selected) {
          this.deleteItem(this.selected[i].id);
        }
      }
    },
    // dialogDelete(val) {

    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
    //     text:
    //       name && id
    //         ? `Anda yakin ingin menghapus item ${name}`
    //         : "Anda yakin ingin menghapus item yang terpilih",
    //     accept: () => {
    //       if (name && id) {
    //         this.delete(id);
    //       } else {
    //         // eslint-disable-next-line no-lonely-if
    //         if (this.selected.length === 0) {
    //           this.$vs.notify({
    //             title: "Tidak ada item yang dipilih",
    //             text: "Pilihlah salah satu item atau semua item",
    //             color: "danger",
    //             position: "top-right",
    //           });
    //         } else {
    //           // eslint-disable-next-line prefer-const
    //           for (let i in this.selected) {
    //             this.delete(this.selected[i].id);
    //           }
    //         }
    //       }
    //     },
    //   });
    // },
    deleteItem(id) {
      this.$vs.loading({
        container: this.$refs.loadSubKatSOS,
        color: "primary",
      });
      this.closeEdit();
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("sos/cudSubKategoriSOS", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Sub-Kategori SOS ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.selected = [];
          this.getData();
          this.itemDelete = null;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSubKatSOS);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = v.link;
          this.addData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.selected = [];
          this.closeEdit();
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadSubKatSOS,
        color: "primary",
      });
      this.$store
        .dispatch("sos/getSubKategoriSOS", {
          ...this.params,
          kat_id: this.passData.id,
          ...this.pagination,
        })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadSubKatSOS);
          this.subKategoris = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSubKatSOS);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let idData = {};
      if (this.itemEdit !== null) {
        idData = {
          id: this.itemEdit.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.$store
        .dispatch("sos/cudSubKategoriSOS", [
          { ...this.formData, kat_id: this.passData.id, ...idData },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.itemEdit !== null
                ? "Edit Sub-Kategori SOS Sukses!"
                : "Tambah Sub-Kategori SOS Sukses!",
            text:
              this.itemEdit !== null
                ? `Sub-Kategori SOS ${v.name} Berhasil diedit`
                : `Sub-Kategori SOS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          idData = {};
          this.selected = [];
          this.closeEdit();
        });
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    // if (this.$store.state.auth.profileAccess !== null) {
    //   if (
    //     this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-SOS"
    //     )
    //   ) {
    //     this.access = this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-SOS"
    //     );
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
